<template>
    <v-list v-if="!isEmpty(items)" three-line>
        <template v-for="(item, key, index) in items">
            <m-card-object :key="key" :item="item" hide-actions/>
            <v-divider  :key="index" v-show="!isLastItem(index)"/>
        </template>
    </v-list>
    <div v-else class="pa-3">
        <e-typography-body-small>{{$t('modules.lists.m-list-dashboard-actions.empty')}}</e-typography-body-small>
    </div>
</template>

<script>
    import {isEmpty} from 'lodash';
    import MCardObject from "@modules/cards/concrete/m-card-object";
    export default {
        name: "m-list-dashboard-actions",
        components: {MCardObject},
        props:{
            items:{
                type: Object
            }
        },
        methods:{
            isLastItem(index){
                return index === Object.keys(this.items).length-1
            },
            isEmpty(val){
                return isEmpty(val)
            }
        }
    }
</script>

<style scoped>

</style>
